import { motion } from "framer-motion";
import e1 from "../../accests/ella/ella.jpeg"
import e2 from "../../accests/pinna/pinna (2).jpeg"
import e3 from "../../accests/kan/kan (3).jpeg"
import e4 from "../../accests/kan/kan (7).jpeg"
import e6 from "../../accests/roundt/kovila (2).jpeg"
import e5 from "../../accests/roundt/kovila (3).jpeg"


// ella
import e7 from "../../accests/ella/train.jpeg"
import e9 from "../../accests/ella/adam.jpeg"
import rawana from "../../accests/ella/rawana.jpeg"
import yaka from "../../accests/ella/yaka.jpeg"
import uda from "../../accests/udawalawa/udawalawa (2).jpeg"
import galla from "../../accests/galle/galle.jpeg"
import kosgoda from "../../accests/galle/tur.jpg"
import koggala from "../../accests/galle/koggala.jpeg"




export default function KandyEllaYalaGalleTour() {
    const whatsapp =
        "https://wa.me/94770163670?text=Hello%20I%20would%20like%20to%20book%20the%204-Day%20Kandy,%20Ella,%20Yala%20Safari%20and%20Galle%20Tour";

    const overview = {
        title: "Experience Sri Lanka’s Culture, Nature & Wildlife on a Four-Day Adventure",
        desc: `Embark on an action-packed four-day journey across Sri Lanka’s most iconic destinations. Begin in Kandy, the cultural capital, and enjoy a scenic train ride to Ella, where you will hike Little Adam’s Peak and Ella’s Rock. Continue with an exciting wildlife safari in Yala National Park and conclude your adventure by exploring the UNESCO-listed Galle Fort. This tour offers the perfect blend of culture, nature, and wildlife for an unforgettable experience.`,
        highlights: [
            "Visit the Temple of the Tooth in Kandy and witness sacred rituals.",
            "Enjoy the stunning train journey from Kandy to Ella.",
            "Hike Little Adam’s Peak and Ella’s Rock with panoramic views.",
            "Go on a thrilling safari in Yala National Park to spot leopards, elephants, and other wildlife.",
            "Discover the historic Galle Dutch Fort and its cultural significance.",
            "Witness the traditional practice of stilt fishing along the southern coast.",
            "Visit the Kosgoda Turtle Hatchery and contribute to marine conservation.",
            "Relax and unwind on the pristine beaches of Bentota.",
        ],
        whenToGo: "This tour is available year-round. The best time to visit is from December to March.",
        tripLength: "04 days",
        language: "English ",
        whatToBring: [
            "Comfortable clothing suitable for walking and outdoor activities",
            "Sturdy footwear for hiking and safari",
            "Hat and sunscreen for sun protection",
            "Insect repellent for safaris",
            "Sunglasses",
            "Bathing gear for beaches or hotel pools",
            "Money for personal expenses or gratuities",
        ],
        transfers: "Hotel – Tour Attractions – Hotel",
        travelTips: [
            "This tour may not be suitable for guests with reduced mobility.",
            "Dress modestly when visiting religious sites: cover shoulders and knees.",
            "Stay hydrated and carry sun protection, especially during outdoor activities.",
        ],
        inclusions: [
            "Air-conditioned private vehicle (car, family van, or luxury bus) for all transfers",
            "Accommodation in quality hotels, villas, or resorts on a half-board basis",
            "Professional English speaking guides for an enriching experience",
            "All costs related to tour excursions, including entrance fees to UNESCO sites, safari jeep fees, and other listed activities",
            "Unlimited mineral water throughout the tour",
            "All government taxes and tariffs included",
            "No hidden or additional charges",
        ],
        exclusions: [
            "Meals and beverages not included in the booked meal plan",
            "Visa and flight arrangements",
            "Personal expenses such as souvenirs, tips, or porterage",
        ]
    };

    const itinerary = [
        {
            day: "Day 1 – Kandy",
            places: [
                {
                    title: "Pinnawala Elephant Orphanage",
                    desc: "Established in 1975, this sanctuary cares for orphaned and injured elephants. Guests can observe elephants bathing, feeding, and interacting with caretakers in a safe environment.",
                    img: e2,
                    link: "https://en.wikipedia.org/wiki/Pinnawala_Elephant_Orphanage",
                },
                {
                    title: "Temple of the Tooth Relic",
                    desc: "A sacred Buddhist temple housing Sri Lanka’s most revered artifact: the tooth relic of Lord Buddha. Witness daily rituals and experience the spiritual ambiance of this UNESCO World Heritage site.",
                    img: e3,
                    link: "https://en.wikipedia.org/wiki/Temple_of_the_Tooth",
                },
                {
                    title: "Royal Botanical Gardens",
                    desc: "Spanning 60 hectares in Peradeniya, these gardens feature over 4,000 plant species, including tropical trees, orchids, and palms. Enjoy a guided walk through its serene landscapes.",
                    img: e4,
                    link: "https://en.wikipedia.org/wiki/Royal_Botanical_Garden,_Peradeniya",
                },
                {
                    title: "Ayurvedic Herbal & Spice Garden",
                    desc: "Discover Sri Lanka’s rich tradition of Ayurveda at this garden filled with medicinal herbs and spices. Learn about their healing properties, enjoy a soothing 10-minute Ayurvedic head massage, and end your visit with a refreshing cup of herbal tea.",
                    img: e5,
                    link: "https://en.wikipedia.org/wiki/Ayurveda",
                },
                {
                    title: "Kandyan Cultural Show",
                    desc: "Experience the ancient art of Kandyan dance, featuring vibrant costumes, drumming, and fire-dancing. This captivating performance immerses you in Sri Lanka’s rich cultural heritage and folklore.",
                    img: e6,
                    link: "https://en.wikipedia.org/wiki/Kandyan_dance",
                },
            ],
        },
        {
            day: "Day 2 – Ella & Tea Country",
            places: [
                {
                    title: "Train Journey from Kandy to Ella",
                    desc: "Experience one of the world’s most scenic train rides, passing tea plantations, waterfalls, and misty mountains.",
                    img: e7,
                    link: "https://en.wikipedia.org/wiki/Ella,_Sri_Lanka",
                },
                {
                    title: "Nine Arch Bridge",
                    desc: "Colonial-era viaduct surrounded by lush jungle and tea estates. A must-visit photography spot in Ella.",
                    img: e1,
                    link: "https://en.wikipedia.org/wiki/Nine_Arch_Bridge,_Demodara",
                },
                {
                    title: "Little Adam’s Peak",
                    desc: "An easy hike with panoramic views of Ella Gap and rolling tea plantations. Ideal for sunrise or sunset photos.",
                    img: e9,
                    link: "https://en.wikipedia.org/wiki/Little_Adam%27s_Peak",
                },
            ],
        },
        {
            day: "Day 3 – Yala Safari",
            places: [
                {
                    title: "Rawana Waterfall",
                    desc: "A beautiful waterfall along the way to Yala, cascading from the highlands. Great for short walks and photos.",
                    img: rawana,
                    link: "https://en.wikipedia.org/wiki/Ravana_Falls",
                },
                {
                    title: "Yala National Park Safari",
                    desc: "Sri Lanka’s premier wildlife reserve, home to leopards, elephants, sloth bears, crocodiles, and 215+ bird species. A thrilling 4x4 safari adventure.",
                    img: yaka,
                    link: "https://en.wikipedia.org/wiki/Yala_National_Park",
                },
                {
                    title: "Udawalawe Elephant Transit Home",
                    desc: "Observe young elephants being fed and learn about conservation efforts to prepare them for reintroduction into the wild.",
                    img: uda,
                    link: "https://en.wikipedia.org/wiki/Udawalawe_National_Park",
                },
            ],
        },
        {
            day: "Day 4 – Galle & Southern Coast",
            places: [
                {
                    title: "Galle Dutch Fort",
                    desc: "A UNESCO World Heritage Site with colonial architecture, cobbled streets, cafes, and ocean views. Explore the fort’s rich history.",
                    img: galla,
                    link: "https://en.wikipedia.org/wiki/Galle_Fort",
                },
                {
                    title: "Kosgoda Turtle Hatchery",
                    desc: "Conservation center protecting endangered sea turtles. Witness egg incubation, baby turtle releases, and educational exhibits.",
                    img: kosgoda,
                    link: "https://en.wikipedia.org/wiki/Kosgoda",
                },
                {
                    title: "Stilt Fishing",
                    desc: "Traditional fishing method of southern Sri Lanka, where fishermen balance on wooden poles to catch fish in shallow waters.",
                    img: koggala,
                    link: "https://en.wikipedia.org/wiki/Stilt_fishing",
                },
            ],
        },
    ];

    return (
        <section className="bg-gray-100 text-gray-900">
            {/* Hero */}
            <div className="relative h-[70vh] flex items-center justify-center bg-gray-800">
                <img
                    src={e1}
                    alt="Sri Lanka Tour"
                    className="absolute inset-0 w-full h-full object-cover opacity-60"
                />
                <div className="relative text-center max-w-4xl px-6">
                    <motion.h1
                        initial={{opacity: 0, y: 30}}
                        animate={{opacity: 1, y: 0}}
                        transition={{duration: 0.8}}
                        className="text-4xl md:text-6xl font-bold text-white"
                    >
                        Kandy → Ella → Yala → Galle
                    </motion.h1>
                    <p className="mt-6 text-lg text-gray-200">
                        Explore Sri Lanka’s culture, nature, and wildlife on an unforgettable four-day adventure.
                    </p>
                </div>
            </div>



                {/* Day-by-Day Itinerary */}
                <div className="max-w-6xl mx-auto px-6 py-20 space-y-20">
                    {itinerary.map((dayItem, i) => (
                        <div key={i}>
                            <h2 className="text-3xl font-bold mb-8">{dayItem.day}</h2>
                            <div className="grid md:grid-cols-2 gap-8">
                                {dayItem.places.map((place, j) => (
                                    <motion.div
                                        key={j}
                                        initial={{opacity: 0, y: 20}}
                                        whileInView={{opacity: 1, y: 0}}
                                        transition={{duration: 0.5}}
                                        className="bg-white rounded-2xl shadow-lg overflow-hidden"
                                    >
                                        <img src={place.img} alt={place.title} className="w-full h-64 object-cover"/>
                                        <div className="p-6">
                                            <h3 className="text-xl font-semibold mb-2">{place.title}</h3>
                                            <p className="text-gray-700 mb-4">{place.desc}</p>
                                            <a href={place.link} target="_blank" rel="noopener noreferrer"
                                               className="text-yellow-500 hover:underline">Read more →</a>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Trip Overview */}
            {/* Trip Overview */}
            <div className="max-w-7xl mx-auto px-6 py-20 space-y-16">
                {/* Overview Header */}
                <div className="text-center space-y-4">
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
                        {overview.title}
                    </h2>
                    <p className="text-gray-600 text-lg md:text-xl max-w-3xl mx-auto">
                        {overview.desc}
                    </p>
                </div>

                {/* Trip Info Cards */}
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                    <div className="bg-yellow-50 p-6 rounded-2xl shadow hover:shadow-lg transition-all">
                        <h3 className="text-xl font-semibold mb-2">Trip Length</h3>
                        <p className="text-gray-700">{overview.tripLength}</p>
                    </div>
                    <div className="bg-yellow-50 p-6 rounded-2xl shadow hover:shadow-lg transition-all">
                        <h3 className="text-xl font-semibold mb-2">Language</h3>
                        <p className="text-gray-700">{overview.language}</p>
                    </div>
                    <div className="bg-yellow-50 p-6 rounded-2xl shadow hover:shadow-lg transition-all">
                        <h3 className="text-xl font-semibold mb-2">Best Time to Go</h3>
                        <p className="text-gray-700">{overview.whenToGo}</p>
                    </div>
                    <div className="bg-yellow-50 p-6 rounded-2xl shadow hover:shadow-lg transition-all">
                        <h3 className="text-xl font-semibold mb-2">Transfers</h3>
                        <p className="text-gray-700">{overview.transfers}</p>
                    </div>
                </div>

                {/* Highlights */}
                <div className="grid md:grid-cols-2 gap-6">
                    {overview.highlights.map((item, i) => (
                        <div key={i} className="bg-white p-6 rounded-2xl shadow hover:shadow-lg transition-all flex items-start space-x-4">
                            <span className="text-yellow-500 font-bold text-2xl">•</span>
                            <p className="text-gray-700">{item}</p>
                        </div>
                    ))}
                </div>

                {/* What to Bring & Travel Tips */}
                <div className="grid md:grid-cols-2 gap-6">
                    <div className="bg-blue-50 p-6 rounded-2xl shadow hover:shadow-lg transition-all">
                        <h3 className="text-2xl font-semibold mb-4">What to Bring</h3>
                        <ul className="list-disc list-inside space-y-2 text-gray-700">
                            {overview.whatToBring.map((item, i) => <li key={i}>{item}</li>)}
                        </ul>
                    </div>
                    <div className="bg-blue-50 p-6 rounded-2xl shadow hover:shadow-lg transition-all">
                        <h3 className="text-2xl font-semibold mb-4">Travel Tips</h3>
                        <ul className="list-disc list-inside space-y-2 text-gray-700">
                            {overview.travelTips.map((item, i) => <li key={i}>{item}</li>)}
                        </ul>
                    </div>
                </div>

                {/* Inclusions & Exclusions */}
                <div className="grid md:grid-cols-2 gap-6">
                    <div className="bg-green-50 p-6 rounded-2xl shadow hover:shadow-lg transition-all">
                        <h3 className="text-2xl font-semibold mb-4">Inclusions</h3>
                        <ul className="list-disc list-inside space-y-2 text-gray-700">
                            {overview.inclusions.map((item, i) => <li key={i}>{item}</li>)}
                        </ul>
                    </div>
                    <div className="bg-red-50 p-6 rounded-2xl shadow hover:shadow-lg transition-all">
                        <h3 className="text-2xl font-semibold mb-4">Exclusions</h3>
                        <ul className="list-disc list-inside space-y-2 text-gray-700">
                            {overview.exclusions.map((item, i) => <li key={i}>{item}</li>)}
                        </ul>
                    </div>
                </div>
            </div>



            {/* WhatsApp CTA */}
                <div className="text-center py-20 bg-gray-900">
                    <motion.a
                        whileHover={{scale: 1.1}}
                        whileTap={{scale: 0.95}}
                        href={whatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex px-16 py-5 bg-yellow-500 text-black font-bold text-xl rounded-full shadow-2xl hover:bg-yellow-400"
                    >
                        Book This 4-Day Sri Lanka Tour
                    </motion.a>
                    <p className="mt-4 text-gray-300 text-sm">
                        📞 Instant WhatsApp booking • 🕒 Flexible itinerary • 🚗 Private transport
                    </p>
                </div>
        </section>
);
}
